import { buildModelsActionCreator } from '../actions';

export const FETCH_ORGANISATIONS_MODEL = 'epic.model.FETCH_ORGANISATIONS_MODEL';

export type FetchOrganisationsModelAction = ReturnType<typeof fetchOrganisationsModelAction>;

export const fetchOrganisationsModelAction = buildModelsActionCreator(FETCH_ORGANISATIONS_MODEL, 'organisations');
